import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=5bf0c27e&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=ts"
export * from "./Subscription.vue?vue&type=script&lang=ts"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=5bf0c27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0c27e",
  null
  
)

export default component.exports